import { render, staticRenderFns } from "./StoreInfoView.vue?vue&type=template&id=72619880&scoped=true"
import script from "./StoreInfoView.vue?vue&type=script&lang=js"
export * from "./StoreInfoView.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoView.vue?vue&type=style&index=0&id=72619880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72619880",
  null
  
)

export default component.exports